import { createReducer, on } from '@ngrx/store';
import { userActions } from '../actions';

export const featureKey = 'user';

export const initialState: any = null;

export const reducer = createReducer(
    initialState,
    on(userActions.setCurrUser, (state, { user }) => ({ ...state, user }))
);
